var _rect, _rect2, _rect3, _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDefaultAreaThumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 293,
    height: 160,
    viewBox: "0 0 293 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3773_2632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 293,
    height: 160
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 160,
    rx: 4,
    fill: "#C4C4C4"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3773_2632)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: -50,
    width: 293,
    height: 286,
    fill: "#E3ECC6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3773_2632",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -50,
    width: 293,
    height: 286
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: -50,
    width: 293,
    height: 286,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3773_2632)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192 32L168.917 128L100 84.2791L192 32Z",
    fill: "#94BE43",
    fillOpacity: 0.6,
    stroke: "#94BE43",
    strokeWidth: 1.42012,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAreaThumbnail);
export default __webpack_public_path__ + "static/media/DefaultAreaThumbnail.148f1ff0c82a728161fc43e9f5338333.svg";
export { ForwardRef as ReactComponent };